// function taken from here (with major modifications): https://stackoverflow.com/a/39235724
export interface ResizeImageOptions {
    maxHeight: number;
    maxWidth: number;
    file: File;
}

export interface ResizeImageResults {
    newFile: File;
    dataUrl: string;
}

export class ImageUtils {
    public resizeImage(settings: ResizeImageOptions): Promise<ResizeImageResults> {
        const file = settings.file;
        const reader = new FileReader();
        const image = new Image();

        return new Promise((resolve, reject) => {
            if (!file.type.match(/image.*/)) {
                reject(new Error('Not an image'));
                return;
            }

            reader.onload = (readerEvent: any) => {
                image.onload = () => resolve(this.resize(image, settings.maxWidth, settings.maxHeight));
                image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
        });
    }

    private resize(image: HTMLImageElement, maxWidth: number, maxHeight: number): ResizeImageResults {
        const canvas = document.createElement('canvas');

        let width = image.width;
        let height = image.height;

        const ratio = Math.min(maxWidth / width, maxHeight / height);

        width = width * ratio;
        height = height * ratio;

        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d')!.drawImage(image, 0, 0, width, height);
        let dataUrl = canvas.toDataURL('image/png');

        return {
            newFile: new File([this.dataURItoBlob(dataUrl)], 'avatar'),
            dataUrl: dataUrl
        };
    }

    private dataURItoBlob(dataURI: string) {
        const bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
            atob(dataURI.split(',')[1]) :
            unescape(dataURI.split(',')[1]);
        const mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const max = bytes.length;
        const ia = new Uint8Array(max);

        for (var i = 0; i < max; i++) {
            ia[i] = bytes.charCodeAt(i);
        }

        return new Blob([ia], { type: mime });
    }
}


// WEBPACK FOOTER //
// ./src/components/imageUpload/ImageUtils.tsx